import TooltipWrapper from "@/components/Tooltip/CustomTooltipWrapper";
import routes from "@/routes";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

interface RoleSelectionProps {
  onRoleSelect: (role: "advertiser" | "agency") => void;
}

export default function RoleSelection({ onRoleSelect }: RoleSelectionProps) {
  const disabled = true; // Disable Agency role selection
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100%",
        paddingTop: 8,
      }}
    >
      <Avatar sx={{ m: 1, bgcolor: "secondary.main", width: 56, height: 56 }}>
        <PersonAddOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h4" sx={{ mb: 4 }}>
        Create Account
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, color: "text.secondary" }}>
        How would you like to use our platform?
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 3,
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <Card
          sx={{
            width: 280,
            cursor: "pointer",
            transition: "all 0.3s",
            "&:hover": {
              transform: "translateY(-4px)",
              boxShadow: 4,
            },
          }}
          onClick={() => onRoleSelect("advertiser")}
        >
          <CardContent sx={{ textAlign: "center", py: 4 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Advertiser
            </Typography>
            <Typography variant="body2" color="text.secondary">
              I want to create and manage advertising campaigns for my business
            </Typography>
          </CardContent>
        </Card>

        <TooltipWrapper title="Agency registration is coming soon!" arrow>
          <Card
            sx={{
              width: 280,
              opacity: disabled ? 0.6 : 1, // Dim the card
              pointerEvents: disabled ? "none" : "auto", // Disable interactions
              cursor: disabled ? "not-allowed" : "pointer", // Change cursor
              bgcolor: "disabledBackground",
            }}
            onClick={() => onRoleSelect("agency")}
          >
            <CardContent sx={{ textAlign: "center", py: 4 }}>
              <Typography variant="h5" sx={{ mb: 2 }}>
                Agency
              </Typography>
              <Typography variant="body2" color="text.secondary">
                I manage advertising campaigns for multiple clients
              </Typography>
            </CardContent>
          </Card>
        </TooltipWrapper>
      </Box>

      <Box sx={{ mt: 4 }}>
        <Typography variant="body2">
          Already have an account?{" "}
          <Link href={routes.LOGIN} underline="hover">
            Sign in
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}
